import React from "react";
import { cn } from "../lib/cn";

interface ConnectionIndicatorProps {
  isConnected: boolean;
  className?: string;
}

export function ConnectionIndicator({
  isConnected,
  className,
}: ConnectionIndicatorProps) {
  return (
    <span
      className={cn("inline-flex items-center gap-1.5 text-xs", className)}
      title={isConnected ? "Realtime connected" : "Connecting…"}
    >
      <span
        className={cn(
          "h-2 w-2 rounded-full",
          isConnected
            ? "bg-green-500 shadow-[0_0_6px_1px_rgba(34,197,94,0.6)] animate-pulse"
            : "bg-yellow-400 animate-pulse",
        )}
      />
      <span className="text-muted-foreground">
        {isConnected ? "Live" : "Connecting"}
      </span>
    </span>
  );
}
